export enum PromoTheme {
  WHITE = 'white',
  BLUE = 'blue',
  BLACK = 'black',
  FULL_BG = 'full_bg',
}
